import { type ActionEvent, Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["experienceRadio"]
  declare readonly experienceRadioTargets: HTMLInputElement[]

  get isDefaultSelected(): boolean {
    return this.defaultExperienceRadio.checked
  }

  resetExperience(): void {
    this.defaultExperienceRadio.click()
  }

  resetIfEmpty({ currentTarget }: ActionEvent): void {
    if (!(currentTarget as HTMLInputElement).value) {
      this.resetExperience()
    }
  }

  private get defaultExperienceRadio(): HTMLInputElement {
    return this.experienceRadioTargets.at(0)!
  }
}
